import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getResellerSecretKeys = () => {
  return axios.get(`${BASE_URL}/api/keys-management/secrets`);
};

export const getResellerLicenseKeys = () => {
  return axios.get(`${BASE_URL}/api/keys-management/licenses`);
};